<template>
    <div style="background: red;" ref="window">
        Info window
    </div>
</template>

<script>
  export default {
    name: "info-window",
    props: ['visible'],

    watch: {
      visible(newVal) {
        if(newVal) {
          this.$refs['window'].style.display = 'block'
        }else {
          this.$refs['window'].style.display = 'none'
        }
      }
    }
  }
</script>

<style scoped>

</style>